export default "__VITE_ASSET__a9b05f62__"